<div class="col-xs-12 is-rtl-flt">
    <h1 class="ttu mb-16 title-s ttu">{{ 'dev.orderStatus.title4' | translate }} {{ orderNumber$ | async }}</h1>
    <div class="mb-32" *ngIf="(orderStatus$ | async).subordersNumber > 1">
        <p class="text-l c-gray">
            {{ 'dev.orderStatus.suborder1' | translate }} {{ (orderStatus$ | async).subordersNumber }}
            {{ 'dev.orderStatus.suborder2' | translate }}
            {{ 'dev.orderStatus.suborder3' | translate }}
        </p>
    </div>
    <div *ngIf="!(orderStatus$ | async)?.items" class="row flex-wrap">
        <div class="is-flex col-xs-12 col-sm-4 p-8 mb-8" *ngFor="let delivery of (orderStatus$ | async).orderDelivery; let i = index; let l = count">
            <div class="is-flex border-1 p-8">
                <div class="align-multi-center is-flex px-16">
                    <svg-icon [src]="delivery.icon"></svg-icon>
                </div>
                <div class="row">
                    <div class="col-xs-12 mb-8">
                        <span class="text-l">{{ 'dev.orderStatus.delivery' | translate }} {{ i + 1 + '/' + l }} </span>
                        -<span class="text-l c-gray"> {{ delivery.id }}</span>
                    </div>
                    <div class="col-xs-12 mb-8">
                        <div class="text-l c-gray">{{ delivery.shippingInfo.name }}</div>
                    </div>
                    <div class="col-xs-12">
                        <div class="text-l c-info">
                            {{ delivery.statusSuborderText }}
                            {{ delivery?.fechaEstimada }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="(orderStatus$ | async)?.items?.length > 0" class="row">
        <div class="col-xs-12">
            <item-order [openedDetail]="true" [order]="orderStatus$ | async"></item-order>
            <order-status-my-account-btn></order-status-my-account-btn>
        </div>
    </div>
</div>
